export enum UserActionTypeExport {
  EditedExportSettings = 'EditedExportSettings',
  ExportCompleted = 'ExportCompleted',
  ExportFileDeleted = 'ExportFileDeleted',
  ExportFileDownloaded = 'ExportFileDownloaded',
  ExportInitiated = 'ExportInitiated'
}
